<template>
	<div>
		<b-modal
			id="testdetails"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showTestDetails"
			v-if="showTestDetails"
			@hidden="$emit('closeTestModal', false)"
		>
			<div
				v-if="loaderStatus"
				class="candash-modal-body-12 d-flex justify-content-center align-items-center overflow-hidden"
				style="height: calc(100vh - 115px) !important"
			>
				<Spinner />
			</div>
			<div class="d-flex w-100" v-else>
				<div class="candash-modal-left width-6"></div>
				<div class="width-94">
					<div class="candash-modal-top px-3 py-2">
						<div class="width-97 ml-1">
							<div class="candash-modal-head">Test Details</div>
							<div class="candash-desc mt-1">
								View your assessment round details
							</div>
						</div>
						<div class="d-flex justify-content-end pointer">
							<img
								class="rotate-on-hover"
								src="../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
								@click="$emit('closeTestModal', false)"
							/>
						</div>
					</div>
					<div class="candash-modal-body-12 d-flex">
						<div class="asp-modal-left-overflow">
							<template v-if="selectedAssessment.companyName">
								<div class="asp-small-grey-txt-2">Company</div>
								<div class="asp-small-grey-txt-3 mt-1 text-truncate">
									{{ selectedAssessment.companyName }}
								</div>
								<div class="asp-small-grey-txt-2 mt-2">Job Title</div>
								<div class="asp-small-grey-txt-3 mt-1 text-break">
									{{ selectedAssessment.jobName || "NA" }}
								</div>
							</template>
							<template v-else>
								<div class="asp-small-grey-txt-2">Organiser</div>
								<div class="asp-small-grey-txt-3 mt-1 text-truncate">
									{{ selectedAssessment.organiser }}
								</div>
							</template>
							<div class="border-bottom mt-3 mb-3"></div>

							<div class="d-flex mt-2">
								<div class="w-50">
									<div class="asp-small-grey-txt-2 d-flex align-items-center">
										<img
											class="mr-1"
											src="../../assets/newdesign/assessPro/blueCalen.svg"
											alt=""
										/>
										Start date :
									</div>
									<div class="asp-small-grey-txt-3 mt-1">
										{{ formatTime(selectedAssessment.config.openTestdt) }},
										{{ formatDate(selectedAssessment.config.openTestdt) }}
									</div>
								</div>
								<div class="w-50">
									<div class="asp-small-grey-txt-2 d-flex align-items-center">
										<img
											class="mr-1"
											src="../../assets/newdesign/assessPro/blueCalen.svg"
											alt=""
										/>
										End date :
									</div>
									<div class="asp-small-grey-txt-3 mt-1">
										{{ formatTime(selectedAssessment.config.closeTestdt) }},
										{{ formatDate(selectedAssessment.config.closeTestdt) }}
									</div>
								</div>
							</div>
							<div class="d-flex mt-2">
								<div class="w-50">
									<div class="asp-small-grey-txt-2">Total attempts</div>
									<div class="asp-small-grey-txt-3 mt-1">
										{{ selectedAssessment.config.maxnoattempts }}
									</div>
								</div>
								<div class="w-50" v-if="selectedAssessment.config.timebnvalue">
									<div class="asp-small-grey-txt-2">Time between attempts</div>
									<div class="asp-small-grey-txt-3 mt-1">
										{{ selectedAssessment.config.timebnvalue }}
										{{ selectedAssessment.config.timebnsel }}
									</div>
								</div>
							</div>
							<div class="d-flex mt-2" v-if="selectedAssessment.negativeMarks">
								<div>
									<div class="asp-small-grey-txt-2">Negative marks</div>
									<div class="asp-small-grey-txt-3 mt-1">
										{{ selectedAssessment.negativeMarks }}
									</div>
								</div>
							</div>
							<div class="asp-small-grey-txt-2 mt-2">Test name</div>
							<div class="asp-small-grey-txt-3 mt-1 word-break">
								{{ selectedAssessment.testName }}
							</div>
							<div
								class="mb-descriptn-txt-1 mt-1"
								v-html="selectedAssessment.config.testDesc"
							></div>
							<!-- Displaying Link to be Copied -->

							<div
								class="d-flex mt-2"
								v-if="selectedAssessment.shareLink && !this.public"
							>
								<div>
									<div class="asp-small-grey-txt-2">Test Link</div>
									<div
										class="d-flex justify-content-between align-items-center"
									>
										<div class="mr-2 mb-mail-txt text-truncate w-92">
											<a
												class="mb-mail-txt"
												target="_blank"
												:href="selectedAssessment.shareLinkWithQuery"
												>{{ shortenLink(selectedAssessment.shareLink) }}</a
											>
										</div>
										<div
											class="pointer"
											@click="
												(isCopied = true),
													copyToClipboard(selectedAssessment.shareLinkWithQuery)
											"
											v-b-tooltip.hover="isCopied ? 'Copied!' : 'Copy'"
										>
											<img
												src="../../assets/newdesign/assessPro/copy.svg"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>

							<template>
								<div class="position-relative mt-4">
									<hr style="border-top: 1px solid #cec1d4" class="my-3" />
									<div
										class="fam-lato fs-14 fw-M color-595959 px-2 position-absolute"
										style="left: 40%; top: -12px; background: white"
									>
										Contents
									</div>
								</div>
								<div
									v-for="(section, index) in sectionDetails"
									:key="section.sectionID"
									class="section-card"
									:class="index == 0 ? 'mt-0' : 'mt-3'"
								>
									<!-- Header -->
									<div
										class="d-flex justify-content-between align-items-baseline p-12px"
										:class="{
											pointer: hasValidBreakdown(section),
											'no-pointer': !hasValidBreakdown(section),
										}"
										v-b-toggle="
											hasValidBreakdown(section) ? 'section-' + index : null
										"
										@click="hasValidBreakdown(section) && toggleSection(index)"
									>
										<div
											class="fw-LM fs-14 fam-lato text-black"
											:class="
												activeSection === index
													? 'section-name-expanded'
													: 'section-name-collapsed'
											"
											:title="
												activeSection !== index ? section.sectionName : ''
											"
										>
											{{ section.sectionName }}
										</div>

										<div class="d-flex align-items-center">
											<span class="mr-2"
												><span class="fw-R fam-mont fs-12 color-3a3c40"
													><img
														src="../../assets/icons/totquestions.svg"
														alt=""
														class="mr-1"
													/>Total Questions: </span
												><span class="fw-LM fam-mont fs-12 color-3a3c40">{{
													section.totalQuestions
												}}</span>
											</span>
											<img
												v-if="hasValidBreakdown(section)"
												class="ml-2"
												:class="{
													rotateArrow: activeSection !== index,
													rotateddown: activeSection === index,
												}"
												src="@/assets/assessment/filteruparw.svg"
											/>
										</div>
									</div>

									<!-- Collapse -->
									<b-collapse
										v-if="hasValidBreakdown(section)"
										:id="'section-' + index"
										accordion="section-accordion"
										class="section-accordion"
									>
										<div class="dashed-divider-td"></div>
										<div class="section-body p-12px">
											<div class="d-flex flex-wrap">
												<template v-for="level in section.difficultyBreakdown">
													<div
														class="level-item mr-3"
														v-if="level.questions > 0"
														:key="level.level"
													>
														<span class="fs-12">
															<img
																src="../../assets/assessment/level.svg"
																alt=""
															/>
															<span class="fw-R">{{ level.level }} : </span>
															<span class="fw-LM">{{ level.questions }}</span>
														</span>
													</div>
												</template>
											</div>
										</div>
									</b-collapse>
								</div>
							</template>
						</div>
						<div class="asp-modal-right-overflow d-flex align-items-center">
							<div class="asp-modal-blue-card w-100">
								<div class="d-flex flex-column align-items-center w-50 mt-4">
									<div>
										<img
											class="mb-2"
											src="../../assets/newdesign/assessPro/Duration.svg"
											alt=""
										/>
									</div>
									<div class="candash-displaytxt-grey">Duration</div>
									<div class="candash-bold-grey">
										{{ selectedAssessment.config.testDuration }}
										mins
									</div>
								</div>
								<div
									class="d-flex flex-column align-items-center w-50 mt-4"
									v-if="selectedAssessment.proctoringType"
								>
									<div>
										<img
											v-if="
												selectedAssessment.proctoringType ===
												'agent-extension-video'
											"
											class="mb-2"
											src="../../assets/newdesign/assessPro/allProctoring.svg"
											alt=""
										/>
										<img
											v-else-if="selectedAssessment.proctoringType === 'video'"
											class="mb-2"
											src="../../assets/newdesign/assessPro/video.svg"
											alt=""
										/>
										<img
											v-else-if="selectedAssessment.proctoringType === 'agent'"
											class="mb-2"
											src="../../assets/newdesign/assessPro/agent.svg"
											alt=""
										/>
										<img
											v-else-if="
												selectedAssessment.proctoringType === 'extension'
											"
											class="mb-2"
											src="../../assets/newdesign/assessPro/extension.svg"
											alt=""
										/>
										<img
											v-else-if="
												selectedAssessment.proctoringType === 'extension-video'
											"
											class="mb-2"
											src="../../assets/newdesign/assessPro/extensionAndVideo.svg"
											alt=""
										/>

										<img
											v-else-if="
												selectedAssessment.proctoringType === 'agent-video'
											"
											class="mb-2"
											src="../../assets/newdesign/assessPro/agentAndVideo.svg"
											alt=""
										/>
										<img
											v-else
											class="mb-2"
											src="../../assets/newdesign/assessPro/extensionAndAgent.svg"
											alt=""
										/>
									</div>
									<div class="candash-displaytxt-grey">Proctoring</div>
									<div class="candash-bold-grey">Enabled</div>
								</div>
								<div class="d-flex flex-column align-items-center w-50 mt-4">
									<div>
										<img
											class="mb-2"
											src="../../assets/newdesign/assessPro/totalQues.svg"
											alt=""
										/>
									</div>
									<div class="candash-displaytxt-grey">Total Questions</div>
									<div class="candash-bold-grey">
										{{ selectedAssessment.totalQuestionsCount }}
									</div>
								</div>
								<div class="d-flex flex-column align-items-center w-50 mt-4">
									<div>
										<img
											class="mb-2"
											src="../../assets/newdesign/assessPro/totalSec.svg"
											alt=""
										/>
									</div>
									<div class="candash-displaytxt-grey">Total Sections</div>
									<div class="candash-bold-grey">
										{{ selectedAssessment.totalSectionsCount }}
									</div>
								</div>
								<div class="d-flex flex-column align-items-center w-50 mt-4">
									<div>
										<img
											class="mb-2"
											src="../../assets/newdesign/assessPro/diffLev.svg"
											alt=""
										/>
									</div>
									<div class="candash-displaytxt-grey">Difficulty Level</div>
									<div class="candash-bold-grey">
										{{ selectedAssessment.intDifficulty }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="candash-modal-footer d-flex align-items-center"
						:class="
							isUpcoming(selectedAssessment)
								? 'justify-content-between'
								: 'justify-content-end'
						"
					>
						<div
							class="d-flex align-items-center asp-yellow-txt"
							v-if="isUpcoming(selectedAssessment)"
						>
							<img
								class="mr-1"
								src="../../assets/newdesign/assessPro/yellowinfo.svg"
								alt=""
							/>You cannot take test before start date
						</div>
						<div class="d-flex">
							<b-button
								class="candash-cancelBtn mr-4"
								@click="$emit('closeTestModal', false)"
								>Cancel</b-button
							>
							<b-button
								v-if="
									isUpcoming(selectedAssessment) &&
									selectedAssessment.setPricing == false
								"
								class="candash-addBtn"
								@click="notifyMe(selectedAssessment)"
								>Notify Me</b-button
							>
							<b-button
								v-else-if="selectedAssessment.attemptsLeft == 0"
								class="candash-addBtn"
								@click="$emit('closeTestModal', false)"
								>Okay</b-button
							>
							<b-button
								v-else-if="
									selectedAssessment.setPricing == true &&
									selectedAssessment.purchased === false
								"
								class="candash-addBtn"
								@click="!hasAccess() ? openLoginModal() : purchaseTest(selectedAssessment)"
							>
								<template
									v-if="
										selectedAssessment.finalPrice !==
										selectedAssessment.listPrice
									"
								>
									<span class="right-container-subhead">
										₹{{ selectedAssessment.finalPrice }}
									</span>

									<span
										style="
											font-family: 'Montserrat', sans-serif;
											font-weight: 400;
											font-size: 13px;
											text-decoration-line: line-through;
											color: #999999;
										"
									>
										₹{{ selectedAssessment.listPrice }}
									</span>
								</template>
								<span v-else>₹{{ selectedAssessment.finalPrice }}</span>
								<span class="mx-1">
									<img src="../../assets/icons/line.svg" alt="" />
								</span>
								Buy Now
							</b-button>
							<b-button
								v-else-if="selectedAssessment.noOfAttemptsTaken == 0"
								class="candash-addBtn"
								@click="!hasAccess() ? openLoginModal() : takeNewTest(selectedAssessment)"
								>Take Test</b-button
							>
							<b-button
								v-else
								class="candash-addBtn"
								@click="!hasAccess() ? openLoginModal() : attemptsLeft(selectedAssessment)"
								>Retake Test</b-button
							>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="emailmodal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="showNotifyMe"
			v-if="showNotifyMe"
			@hidden="showNotifyMe = false"
		>
			<div class="d-flex flex-column align-items-center justify-content-center">
				<img src="../../assets/newdesign/assessPro/emailNoti.svg" alt="" />
				<div class="text-center asp-black-txt-3 mt-4">
					You will receive an email notification<br />
					shortly
				</div>
				<b-button class="candash-addBtn mt-4" @click="showNotifyMe = false"
					>Okay</b-button
				>
			</div>
		</b-modal>
		<div style="display: none" ref="responseContainer"></div>
	</div>
</template>
<script>
import {
	getShareLink,
	getParticularsectionDetails,
	getGlobalTrending,
	postPurchaseTest,
} from "@/utils/apiFunctions";
import { hasAccess } from "@/utils/tokenCheck";
import EventBus from "../../utils/EventBus";
import { mapGetters } from "vuex";
import { trackSelfAssessPlayed } from '@/utils/posthogHelpers';
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import payment from "../../components/mixin/payment.js";
import { trackEvent } from "@/tracking/events";
import toast from "../../components/mixin/toast.js";

export default {
	name: "TestDetails",
	props: {
		selectedAssessment: Object,
		showTestDetails: Boolean,
		public: Boolean,
		cardType: {
			type: String,
			default: "default", // default, completed, upcoming, ongoing
		},
	},
	mixins: [payment, toast],

	data() {
		return {
			isCopied: false,
			showNotifyMe: false,
			loaderStatus: false,
			sectionDetails: [],
			activeSection: null,
		};
	},
	components: {
		Spinner,
	},
	created() {
		this.getTestDetails();
		this.getTrendingAssessment();
	},
	methods: {
		hasValidBreakdown(section) {
			return (
				section.difficultyBreakdown &&
				section.difficultyBreakdown.some((level) => level.questions > 0)
			);
		},
		purchaseTest(assessment) {
			if (!hasAccess()) {
				EventBus.$emit("open-login-modal", true);
				return;
			}
			this.loaderStatus = true;
			this.selectedAssessment = assessment;
			this.checkCustomer();
		},
		async postPurchaseTest() {
			if (!this.orderID) return;
			try {
				const reference =
					this.cardType === "completed" ||
					this.cardType === "upcoming" ||
					this.cardType === "ongoing"
						? this.selectedAssessment.referenceID
						: this.selectedAssessment.testID;

				let payload = {
					references: [reference],
					orderID: this.orderID,
					email: this.userInfo.email,
					pricingID: this.selectedAssessment.pricingID,
				};

				const response = await postPurchaseTest(payload);
				console.log("Purchase Test Response:", response);
				// this.$emit("refreshPublicTests");
				// this.assessment.purchased = true;
				this.selectedAssessment.purchased = true;
				this.loaderStatus = false;
				this.successModal("Success", "Test purchased successfully!");
				trackEvent("assessment_purchased", { assessmentID: this.selectedAssessment.testID });
				this.$emit("purchase-success");
			} catch (error) {
				console.error("Error purchasing test:", error);
			} finally {
				this.loaderStatus = false;
			}
		},
		toggleSection(index) {
			this.activeSection = this.activeSection === index ? null : index;
		},
		async getTestDetails() {
			try {
				console.log("Calling API for test:", this.selectedAssessment.testID);

				const res = await getParticularsectionDetails(
					this.selectedAssessment.testID
				);

				if (res.status === 200) {
					this.sectionDetails = res.data.data.sections;
					console.log("Section Details:", this.sectionDetails);
				} else {
					console.error("Failed to fetch section details. Status:", res.status);
				}
			} catch (err) {
				console.error("API error:", err);
			}
		},
		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},
		takeNewTest(assessment) {
			trackEvent("assessment_opened", { assessmentID: assessment.testID });
			// Construct query parameters for the redirect page
			const query = {
				testID: assessment.testID,
				publicConfigType: assessment.publicConfigType || 0,
				isPublic: assessment.isPublic || false,
			};
			const link = assessment.shareLinkWithQuery || assessment.shareLink;
			if (!assessment.isPublic && link) {
				query.shareLink = link;
			}

			// Create the local URL for the redirect page
			const routeData = this.$router.resolve({
				name: "AssessmentRedirect",
				query: query,
			});

			// Open the redirect page in a new tab synchronously
			window.open(routeData.href, "_blank");
		},
		hasAccess() {
			return hasAccess();
		},
		attemptsLeft(assessment) {
			console.log("assessmentassessmentassessmentassessment", assessment);
			const query = {
				testID: assessment.testID,
				publicConfigType: assessment.publicConfigType || 0,
				isPublic: false,
			};

			if (assessment.shareLink) {
				query.shareLink = assessment.shareLink;
			}

			// Create the local URL for the redirect page
			const routeData = this.$router.resolve({
				name: "AssessmentRedirect",
				query: query,
			});

			// Open the redirect page in a new tab synchronously
			window.open(routeData.href, "_blank");
		},
		appendQuery(link, query) {
			let url = new URL(link);
			url.searchParams.append(query.key, query.value);
			return url.href;
		},
		goBack() {
			this.$router.go(-1);
		},
		openLink(link) {
			window.open(link, "_blank");
		},
		formatDate(date) {
			return new Date(date)
				.toLocaleString("en-IN", {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
				})
				.replaceAll("/", "-");
		},
		formatTime(date) {
			return new Date(date).toLocaleString("en-IN", {
				hour: "numeric",
				minute: "numeric",
				hour12: true,
			});
		},
		shortenLink(link) {
			return "https://.../" + link.split("/").slice(-1);
		},
		copyToClipboard(text) {
			this.$copyToClipboard(text);
		},
		notifyMe(assessment) {
			this.showNotifyMe = true;
		},
		isUpcoming(assessment) {
			return (
				new Date(assessment.config?.openTestdt).getTime() > new Date().getTime()
			);
		},
		viewTestDetails(assessment) {
			this.selectedAssessment = Object.assign({}, assessment);
			this.selectedAssessment.proctoringType =
				this.getProctoringType(assessment);
			this.showTestDetails = true;
			this.currentMobileScreen = MOBILE_TEST_DETAILS;
		},
		async getTrendingAssessment() {
			try {
				let payload = {
					type: "assessment",
					interactionType: "click",
					referenceID:
						this.selectedAssessment?.testID || this.$route.query.testID,
				};
				const response = await getGlobalTrending(payload);
			} catch (error) {
				console.log(error);
			}
		},
	},

	computed: {
		paymentItemID() {
			return this.selectedAssessment?.paymentItemID;
		},
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
};
</script>

<style>
.asp-modal-left-overflow {
  height: 100%;
  overflow: auto;
  width: 50%;
  padding: 12px 12px 11px 36px;
}

.asp-modal-right-overflow {
  height: 100%;
  overflow: auto;
  width: 50%;
  padding: 12px 44px 12px 16px;
}

.asp-modal-blue-card {
  border-radius: 14px;
  background: #f2f7fb;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  /* height: 420px; */
}

.asp-modal-blue-card > * {
  flex: 1 1 50%;
}
.section-card {
	background: #ffffff;
	border: 1px solid #efefef;
	border-radius: 8px;
	overflow: hidden;
}
.p-12px {
	padding: 12px;
}
.section-accordion {
	background: #f6f9fb;
}
.dashed-divider-td {
	width: 100%;
	height: 1px;
	background-image: repeating-linear-gradient(
		to right,
		#d1d5db 0px,
		#d1d5db 8px,
		transparent 8px,
		transparent 10px
	);
}
.rotateArrow {
	transform: rotate(180deg);
	transition: transform 0.3s ease;
}
.rotateddown {
	transform: rotate(0);
}
.no-pointer {
	cursor: default;
}
.section-name-collapsed {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 180px;
}
.section-name-expanded {
	white-space: normal;
	word-break: break-word;
	max-width: 185px;
}

/* Ensure backdrop covers GuestHeader when user is logged out */
#testdetails___BV_modal_backdrop_ {
	top: 0 !important;
	height: 100vh !important;
}
</style>
